import { getOwner, runWithOwner } from "solid-js";

import UCrypto from "@repo/utils/UCrypto";
import UHTMLScriptElement from "@repo/utils-client/UHTMLScriptElement";

import { AnalyticsEvents, Registration } from "~/analytics/client";
import { scriptSrc } from "~/analytics/utils";
import appSettings from "~/appSettings";
import { useUser } from "~/state/features/user";
import Marketing from "~/utils/Marketing";

const id = appSettings.marketing.podscribeId;

declare global {
  interface Window {
    podscribe: (...args: any[]) => void;
  }
}

export default async (): Promise<Registration.Conversion> => {
  if (!id) return;
  if (import.meta.env.APP_ENV !== "production") return;

  // Does not queue events, need to wait for script to load and include global
  await UHTMLScriptElement.inject(
    scriptSrc("https://d34r8q7sht0t9k.cloudfront.net/tag.js"),
    {
      id: "podscribe-capture",
      async: true,
    }
  );

  window.podscribe("init", { user_id: id, advertiser: "kikoff" });
  window.podscribe("view");

  const eventByName: Record<keyof AnalyticsEvents["conversion"], string> = {
    Signup: "signup",
    "Credit Account Open": "lead",
    "Make Credit Line Payment": "purchase",
  };

  return {
    identify() {
      // Do nothing
    },
    async track(name, properties) {
      const [user] = useUser();

      const owner = getOwner()!;

      const emailHash = await UCrypto.sha256Hex(user.pii()?.email);

      window.podscribe(eventByName[name], {
        hashed_email: emailHash,
        ...(() => {
          if (name === "Make Credit Line Payment") {
            const expectedLtv = runWithOwner(owner, () =>
              Marketing.useExpectedLtv(properties)
            );

            return {
              value: expectedLtv,
              order_number: properties.accountId,
            };
          }
        })(),
      });
    },
  };
};
